export default __webpack_public_path__ + "static/media/2.70b36cb4.svg";